import React from 'react'

import OpKeywordAdvancedSetting from './OpKeywordAdvancedSetting'
import FieldRow from './FieldRow'
import FieldNumber from './FieldNumber'

// Zero Sale Targets
const OpKeywordSale = ({ settings, onChange, ...props }) => (
  <>
    <OpKeywordAdvancedSetting
      isOriginal
      tooltip="These are targets that have clicks but zero sales over the selected lookback period. You may wish to pause or lower bids."
      settings={settings}
      noGeniusBid
      onChange={onChange}
      {...props}
    >
      <FieldRow>
        <FieldNumber
          label="Clicks and no sales"
          field="op_adv_zero_sale_clicks"
          settings={settings}
          onChange={onChange}
        />
        <div className="field-wrapper">
        </div>
      </FieldRow>
    </OpKeywordAdvancedSetting>
    {
      settings[`copy_${props.prefix}active`] && (
        <OpKeywordAdvancedSetting
          settings={settings}
          noGeniusBid
          onChange={onChange}
          {...props}
        >
          <FieldRow>
            <FieldNumber
              label="Clicks and no sales"
              field="copy_op_adv_zero_sale_clicks"
              settings={settings}
              onChange={onChange}
            />
            <div className="field-wrapper">
            </div>
          </FieldRow>
        </OpKeywordAdvancedSetting>
      )
    }
  </>
)

export default OpKeywordSale
